export default "__VITE_ASSET__yZpunulS__"